import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import numeral from 'numeral';
import { css } from '@bd/bdui-styles/emotion';
import { Image } from '@bd/bdcore-utilities';
import { Link } from '@bd/bdcore-named-routes';
import withData from '@bd/bdcore-data';
import icons from './IconsList';

import { colors } from '../styles';

const styles = css`
  width: 100%;
  background-color: ${colors.white};
  display: flex;

  .HomeCard_media {
    display: none;
    width: 105px;
    height: 74px;
    position: relative;
    @media(min-width: 700px) {
      display: block;
    }
    .HomeCard_image {
      width: 100%;
      height: 100%;
      object-fit: cover;
      filter: contrast(125%);
      transition: all .5s ease-out;
      &:hover {
        filter: grayscale(10%);
        transition: all .5s ease-out;
      }
    }
  }
  .HomeCard_content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .HomeCard_address {
      display: flex;
      border-bottom: 1px solid #E9E9E9;
      margin: 0 0 0 10px;
      .HomeCard_street {
        font-size: 20px;
        color: #5B909C;
        letter-spacing: 0;
        line-height: 25px;
        margin-bottom: 2px;
      }
      .HomeCard_city {
        font-weight: 700;
        font-size: 12px;
        color: #3F3F3F;
        letter-spacing: 1.6px;
        text-transform: uppercase;
      }
    }
    .HomeCard_iconList {
      list-style: none;
      margin: 0 0 0 10px;
      padding-left: 0;
      display: flex;
      height: 32px;
      align-items: center;
      border-bottom: 1px solid #E9E9E9;
      justify-content: center;
      li {
        flex-grow: 1;
        display: flex;
        justify-content: center;
        height: 100%;
        align-items: center;
        .HomeCard_iconListIcon {
          margin-right: 5px;
        }
        .HomeCard_iconText {
          font-size: 12px;
          color: #3F3F3F;
          letter-spacing: 0.5px;
          @media(min-width: 992px) {
            font-size: 12px;
            text-transform: uppercase;
          }
        }
      }
    }
  }
  .HomeCard_imageMapBtn {
    width: 70% !important;
    position: absolute !important;
    top: 136px;
    left: 50%;
    transform: translateX(-50%);
    height: 40px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
    font-size: 13px;
    font-weight: 800;
    color: ${colors.white};
    background-color: ${colors.color2};
    transition: all .3s ease-out;
    @media(min-width: 992px) {
      top: 210px;
    }
    &:hover {
      background-color: ${colors.color2Darkest};
      transition: all .3s ease-out;
    }
  }
  .HomeCard_communityWrapper {
    display: flex;
    margin: 5px 0 0 10px;
    flex-direction: column;

    .HomeCard_item {
      font-weight: 900;
      font-size: 10px;
      color: #3F3F3F;
      letter-spacing: 1px;
      text-transform: uppercase;
      @media(min-width: 500px) {
        letter-spacing: 2px;
      }
      .HomeCard_itemDetails {
        font-size: 12px;
        color: ${colors.color1};
        text-transform: capitalize;
        letter-spacing: 0;
        transition: all .3s ease-out;
        &:hover {
          color: ${colors.color1Lightest};
          transition: all .3s ease-out;
        }
      }
    }
  }
  .HomeCard_priceWrapper {
    margin: 10px 20px;
    @media(min-width: 992px) {
      display: none;
    }
    .HomeCard_priceValue {
      font-weight: 300;
      font-size: 15px;
      color: #3F3F3F;
      letter-spacing: 0;
      b {
        font-weight: 800;
      }
    }
  }
  .HomeCard_detailButton {
    height: 32px;
    width: 55px;
    position: relative;
    left: 80%;
    background-color: ${colors.color1};
    background-image: url('/images/icons/arrow-right-white.svg');
    background-position: center;
    background-repeat: no-repeat;
    transition: all .3s ease-out;
    @media(min-width: 500px) {
      position: absolute;
      bottom: 10px;
      right: 15px;
      left: unset;
    }
    &:hover {
      background-color: ${colors.color2Darkest};
      transition: all .3s ease-out;
    }
  }
`;


function HomeCard({ home, plan, community, widget }) {
  const comingSoon = get(widget, 'default_image.contentUrl');
  // const communityPrice = get(home, 'price') > 0 ? numeral
  // (get(home, 'price')).format('$0,0') : 'Call for Pricing';
  return (
    <div className={styles}>
      <div className="HomeCard_media">
        <Link name="home-detail" home={home}>
          {
            get(home, 'photos[0].contentUrl') &&
            <Image
              src={get(home, 'photos[0].contentUrl')}
              alt={get(home, 'address.streetAddress')}
              className="HomeCard_image"
              exact
            />
          }
          {
            !get(home, 'photos[0].contentUrl') &&
            <img
              src={comingSoon}
              alt={get(home, 'photos[0].name', '')}
              className="HomeCard_image"
            />
          }
        </Link>
      </div>
      <div className="HomeCard_content">
        <div className="HomeCard_address">
          <Link name="home-detail" home={home}>
            <h4 className="HomeCard_street">{get(home, 'address.streetAddress').split(',')[0]}</h4>
            <h5 className="HomeCard_city">{get(home, 'address.addressLocality')}, {get(home, 'address.addressRegion')} {get(home, 'address.postalCode')}</h5>
          </Link>
        </div>
        <ul className="HomeCard_iconList">
          {
            get(home, 'beds') &&
            <li>
              <span className="HomeCard_iconListIcon"><img src={get(icons, 'beds')} alt="" /></span>
              <span className="HomeCard_iconText"><b>{get(home, 'beds')}</b>&nbsp;Beds</span>
            </li>
          }
          {
            get(home, 'bathsFull') &&
            <li>
              <span className="HomeCard_iconListIcon"><img src={get(icons, 'baths')} alt="" /></span>
              <span className="HomeCard_iconText"><b>{get(home, 'bathsFull')}{get(home, 'bathsHalf', 0) > 0 && '.5'}</b>&nbsp;Baths</span>
            </li>
          }
          {
            get(home, 'sqft') &&
            <li>
              <span className="HomeCard_iconListIcon"><img src={get(icons, 'sqft')} alt="" /></span>
              <span className="HomeCard_iconText"><b>{numeral(get(home, 'sqft')).format('0,0')}</b>&nbsp;SQ FT</span>
            </li>
          }
        </ul>
        <div className="HomeCard_communityWrapper">
          {
            get(community, 'name') &&
            <span className="HomeCard_item">Neighborhood: <Link name="community-detail" community={community} className="HomeCard_itemDetails">{get(community, 'name')}</Link></span>
          }
          {
            get(plan, 'name') &&
            <span className="HomeCard_item">Floor Plan: <Link name="plan-detail" plan={plan} className="HomeCard_itemDetails">{get(plan, 'name')}</Link></span>
          }
        </div>
        <Link name="home-detail" home={home} className="HomeCard_detailButton" />
      </div>
    </div>
  );
}

HomeCard.propTypes = {
  home: PropTypes.object.isRequired,
  plan: PropTypes.object,
  community: PropTypes.object,
  widget: PropTypes.object.isRequired,
};

HomeCard.defaultProps = {
  plan: undefined,
  community: undefined,
};

export default withData(
  {
    home: true,
    plan: true,
    community: true,
    builder: true,
    widget: 'default_image',
  },
  {
    required: {
      home: true,
      widget: true,
    },
  },
)(HomeCard);



// WEBPACK FOOTER //
// ./src/components/HomeMapCard.js